import { render, staticRenderFns } from "./DomainTransfer.vue?vue&type=template&id=473fad02&"
import script from "./DomainTransfer.vue?vue&type=script&lang=js&"
export * from "./DomainTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473fad02')) {
      api.createRecord('473fad02', component.options)
    } else {
      api.reload('473fad02', component.options)
    }
    module.hot.accept("./DomainTransfer.vue?vue&type=template&id=473fad02&", function () {
      api.rerender('473fad02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainTransfer.vue"
export default component.exports